import React, { useEffect } from 'react'

import SprintEnabledBlock from './SprintEnabledBlock'
import ActivityAndStreak from './ActivityAndStreak'
import ActivitiesGraph from './ActivitiesGraph'
import ActivityColorPanel from './ActivityColorPanel'
import Sprint from './Sprint'
import SprintAchieved from './SprintAchieved'

const id = 'my-progress-dashboard'

const MyProgressDashboard = ({
  isSprintAchieved,
  isShownSprintInformation,
  sprintResult,
  sprint,
  badges,
  setComponentsHeight,
  showStats,
  pending,
}) => {
  useEffect(
    () => {
      setComponentsHeight(id)
    },
    [showStats, pending]
  )
  return (
    <div id={id}>
      {isSprintAchieved && <SprintAchieved sprintResult={sprintResult} />}
      {isShownSprintInformation && <Sprint sprint={sprint} />}
      <ActivityAndStreak />
      {badges && badges.achievedBadges && !!badges.achievedBadges.length && <SprintEnabledBlock badges={badges} />}
      <ActivitiesGraph showStats={showStats} pending={pending} />
      <ActivityColorPanel />
    </div>
  )
}

export default MyProgressDashboard
